export enum DataCollectionsRoutes {
  CreateOne = 'create-one',
  FindLast = 'find-last',
  FindLastInProgress = 'find-last-in-progress',
  GetOne = 'get-one',
  Search = 'search',
  ShotSummaries = 'shot-summaries',
  UpdateOne = 'update-one',
}
